import React, { useState } from 'react'
import '../css/components/Login.css';
import Logo from '../assets/logo.png';
import 'animate.css';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import LoginRight from '../assets/login-right.png';

const Login = () => {
  const [response, setResponse] = useState(false);
  const [formData, setFormData] = useState({
    mobile: '',
    // category: '',
    password: '',
  });
  const navigate = useNavigate();
  const [responseStatus, setResponseStatus] = useState();
  const [loading, setLoading] = useState(false);


  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle sign-in
  const handleSignin = async (e) => {
    e.preventDefault();
    // if (!formData.category) {
    //   setResponse('Select Category First');
    //   setResponseStatus('error');
    //   setTimeout(() => {
    //     setResponse('');
    //   }, 2000);
    //   return;
    // }

    // if (
    //   (formData.mobile != 9876543210 && formData.password != 9876 && formData.category == 'admin') ||
    //   (formData.mobile == 9876543210 && formData.password == 9876 && formData.category != 'admin')
    // ){      setResponse('Select Proper Category');
    //   setResponseStatus('error');
    //   setTimeout(() => {
    //     setResponse('');
    //   }, 2000);
    //   return;      
    // }


    setLoading(true);


    try {
      const response = await fetch('https://api.kcmstore.in/dist/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setLoading(false);

      if (response.ok) {
        if (result[0].mobile == '9438244971' && result[0].password == '9438') {
        // if (result[0].mobile == '9876543210' && result[0].password == '9876') {
          localStorage.setItem('userData', JSON.stringify(result));
          localStorage.setItem('isAdmin', 'true');
          setResponse('Login Success. Welcome Admin!');
          setResponseStatus('success');
          setTimeout(() => {
            setResponse('');
            navigate('/admin-dashboard');
            window.location.reload();
          }, 2000);
        }
        else {
          localStorage.setItem('userData', JSON.stringify(result));
          localStorage.setItem('isUser', 'true');
          setResponse('Login Success. Welcome Retailer!');
          setResponseStatus('success');
          setTimeout(() => {
            setResponse('');
            navigate('/dashboard');
            window.location.reload();
          }, 2500);
        }
      } else if (response.status == 400) {
        setResponse(result.message || 'Login failed. Please try again.');
        setResponseStatus('error');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.log('error', error);
    }
  };


  return (
    <>
      <section className='login-bg'>

        <div className='row'>

          <div className='col-lg-6 col-12 align-content-center px-lg-5 px-4 my-4'>
            <div className='login-left col-lg-9 col-md-9 col-sm-9 animate__animated animate__fadeInLeft'>
              <img src={Logo} className='login-logo' alt='Logo' />
              {/* <p className="tagline mt-0">KCM Online Store</p> */}

              {response && (
                <p className={`fw-semibold my-3 rounded-2 fs-6 ${responseStatus === 'success' ? 'text-success' : 'text-danger'}`}>
                  {responseStatus === 'success' ? <i className="fa-solid fa-circle-check"></i> : <i className="fa-solid fa-circle-xmark"></i>} {response}
                </p>
              )}

              {loading && (
                <div>
                  <i class="fa-solid fa-spinner text-dark animate__animated animate__rotateIn animate__infinite fs-5 mt-3"></i>
                </div>
              )}


              <form class="row g-4 mt-3" onSubmit={handleSignin}>
                <div class="col-12 my-2">
                  <input type="tel" class="login-input" id="inputMobile4" maxLength='10' name='mobile' value={formData.mobile} onChange={handleChange} placeholder='Mobile Number' />
                </div>
                  {/* <label className="text-muted" htmlFor="sellPriceTax">Select Category</label> */}
                {/* <div className="col-12 my-2 text-start">
                  <select
                    className="login-input"
                    id="inputCategory"
                    name='category'
                    value={formData.category}
                    onChange={handleChange}
                  >
                                                    <option value="" disabled>Select Category</option>
                    <option value="admin">Admin</option>
                    <option value="retailer">Retailer</option>
                  </select>
                </div> */}
                <div class="col-12 my-2">
                  <input type="password" class="login-input" id="inputPassword4" name='password' value={formData.password} onChange={handleChange} placeholder='Enter Password' />
                </div>
                <div class="col-12 mt-4">
                  <button type="submit" class="login-btn w-100">Sign In</button>
                </div>
              </form>

            </div>
          </div>


          <div className='col-lg-6 col-12 login-right animate__animated animate__fadeInTopRight order-lg-last order-first'>
            <div className='login-right-inner'>
              <p className='login-heading'>KCM Online Store<br />Software</p>
              {/* <img src={LoginRight} className='img-fluid' /> */}
            </div>
          </div>


        </div>
        {/* row ends */}

<div className='copyright-area'>
<p className='py-2 mb-1'>Developed By 
  <Link to='https://www.digithack.in/' target='_blank' className='text-decoration-none'> Digit Hack Software Solutions</Link> | All Rights Reserved. </p></div>


      </section>

      {/* {response && <ResponseMsg message={response} />} */}

    </>
  )
}

export default Login
